import { render, staticRenderFns } from "./compPay.vue?vue&type=template&id=6acd8ed1&"
import script from "./compPay.vue?vue&type=script&lang=js&"
export * from "./compPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6acd8ed1')) {
      api.createRecord('6acd8ed1', component.options)
    } else {
      api.reload('6acd8ed1', component.options)
    }
    module.hot.accept("./compPay.vue?vue&type=template&id=6acd8ed1&", function () {
      api.rerender('6acd8ed1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/components/compPay.vue"
export default component.exports